import React from 'react'
import { Document, Smallarw } from '../../../assests/ExportImageIcon'
import './dataPrivacy.css'

const DATA_CATEGORIES = [
    { title: 'Personal Information', desc: 'Profile, Contact details, Preferences', size: 'Size: 2.4 MB' },
    { title: 'Booking History', desc: '12 bookings, Payment history, Invoices', size: 'Size: 2.4 MB' },
    { title: 'Usage Data', desc: 'App usage, Search history, Interactions', size: 'Size: 2.4 MB', fullWidth: true },
]

const DATA_RIGHTS = [
    { title: 'Right to Access', subtitle: 'Request a copy of your data' },
    { title: 'Right to Rectification', subtitle: 'Correct inaccurate data' },
    { title: 'Right to Erasure', subtitle: 'Request data deletion' },
    { title: 'Right to Portability', subtitle: 'Transfer your data' },
    { title: 'Right to Object', subtitle: 'Object to data processing' },
]

const DATA_USAGE = [
    { title: 'Service Delivery', desc: 'Process bookings, payments, and provide customer support' },
    { title: 'Personalization', desc: 'Customize your experience and provide relevant recommendations' },
    { title: 'Security & Fraud Prevention', desc: 'Protect your account and prevent fraudulent activities' },
    { title: 'Analytics & Improvement', desc: 'Analyze usage patterns to improve our services' },
]

const BackArrow = () => (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
        <path d="M15 9H4M8 5l-4 4 4 4" stroke="#026D4D" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
)

const ShieldIcon = () => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path d="M10 1.66667L16.6667 4.16667V9.16667C16.6667 13.0917 13.8517 16.7417 10 18.3333C6.14833 16.7417 3.33333 13.0917 3.33333 9.16667V4.16667L10 1.66667Z" stroke="#026D4D" strokeWidth="1.5" strokeLinejoin="round" />
    </svg>
)

const DataPrivacy = ({ onBack }) => {
    return (
        <div className='dataPrivacy'>
            <div className='tripDocHeader' onClick={onBack}>
                <BackArrow />
                <span className='bsSectionTitle'>Data &amp; Privacy</span>
            </div>

            <div className='bgWhite commonBorder borderRadius20 paddingCommon20 mt-3'>
                <div className='kycDocCard__head'>
                    <span className='kycDocCard__icon'><ShieldIcon /></span>
                    <div>
                        <div className='kycDocCard__title'>Your Data</div>
                        <div className='kycDocCard__number'>Total data stored: 12.3 MB</div>
                    </div>
                </div>
                <div className='bookingConfirmActions'>
                    <button type='button' className='bookingDownloadBtn'>Download</button>
                    <button type='button' className='bookingDownloadBtn tripDocCancelBtn'>Delete</button>
                </div>
            </div>

            <div className='bsSectionTitle mt-4'>Data Categories</div>
            <div className='kycDocGrid'>
                {DATA_CATEGORIES.map((cat, index) => (
                    <div className={`bgWhite commonBorder borderRadius20 paddingCommon20 ${cat.fullWidth ? 'dataPrivacy__fullSpan' : ''}`} key={index}>
                        <div className='kycDocCard__head kycDocCard__head--spaced'>
                            <span className='kycDocCard__icon'><img src={Document} alt="" /></span>
                            <div>
                                <div className='kycDocCard__title'>{cat.title}</div>
                                <div className='kycDocCard__number'>{cat.desc}</div>
                                <div className='kycDocCard__date'>{cat.size}</div>
                            </div>
                        </div>
                        <button type='button' className='travellerAddBtn kycDocUploadBtn'>Download</button>
                    </div>
                ))}
            </div>

            <div className='bsSectionTitle mt-4'>Your Data Rights</div>
            <div className='bgWhite commonBorder borderRadius20'>
                {DATA_RIGHTS.map((right, index) => (
                    <div className='securityMenuItem' key={index}>
                        <div className='securityMenuItem__info'>
                            <div className='securityMenuItem__title'>{right.title}</div>
                            <div className='securityMenuItem__subtitle'>{right.subtitle}</div>
                        </div>
                        <img src={Smallarw} alt="" className='securityMenuItem__arrow' />
                    </div>
                ))}
            </div>

            <div className='bsSectionTitle mt-4'>How We Use Your Data</div>
            <div className='bsBox'>
                {DATA_USAGE.map((usage, index) => (
                    <div className='dataUsageItem' key={index}>
                        <div className='dataUsageItem__title'>{usage.title}</div>
                        <div className='dataUsageItem__desc'>{usage.desc}</div>
                    </div>
                ))}
            </div>

            <div className='bsSectionTitle mt-4'>Document Guidelines</div>
            <div className='bsBox'>
                <p className='bookingConfirmSentText'>
                    We take your privacy seriously. All data is encrypted and stored securely. We never sell your personal information to third parties.
                </p>
            </div>

            <div className='bsBox mt-4'>
                <p className='bookingConfirmSentText mb-3'>Have questions about your data or privacy?</p>
                <button type='button' className='travellerAddBtn kycDocUploadBtn'>Contact Privacy Team</button>
            </div>
        </div>
    )
}

export default DataPrivacy
